const styles = theme => ({
    divisionAvatar: {
        width: 40,
        height: 40
    },
    projectAvatar: {
        width: 40,
        height: 40
    },
    siteAvatar: {
        width: 40,
        height: 40
    },
    zoneAvatar: {
        width: 40,
        height: 40
    },
});

export default styles;